import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 12,
	viewBox: "0 0 16 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path",
				d: "M1 6H15",
				stroke: "#323E48",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_2",
				d: "M6 11L1 6",
				stroke: "#323E48",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_3",
				d: "M6 1L1 6",
				stroke: "#323E48",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgArrowLeft;
